import { useCallback, useEffect } from 'react';

export const useUnsavedChangesWarning = (hasUnsavedChanges, onCancelConfirmed) => {
  const handleBeforeUnload = useCallback((event) => {
    if (hasUnsavedChanges) {
      event.preventDefault();
    }
  }, [hasUnsavedChanges]);
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload, hasUnsavedChanges]);

  const handleCancel = () => {
    if (onCancelConfirmed) {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      onCancelConfirmed();
    }
  };

  return handleCancel;
};
